import React from 'react';
import { ACHIEVEMENTS } from '@/lib/mockData';

const legendaryCount = ACHIEVEMENTS?.filter((a) => a?.rarity === 'legendary')?.length;
const epicCount = ACHIEVEMENTS?.filter((a) => a?.rarity === 'epic')?.length;
const rareCount = ACHIEVEMENTS?.filter((a) => a?.rarity === 'rare')?.length;

const stats = [
  { id: 'hstat-total', label: 'Total Achievements', value: ACHIEVEMENTS?.length?.toString(), accent: '#f59e0b' },
  { id: 'hstat-legendary', label: 'Legendary', value: legendaryCount?.toString(), accent: '#f59e0b' },
  { id: 'hstat-epic', label: 'Epic', value: epicCount?.toString(), accent: '#a855f7' },
  { id: 'hstat-rare', label: 'Rare', value: rareCount?.toString(), accent: '#06b6d4' },
];

export default function HallStats() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8">
      {stats?.map((stat) => (
        <div
          key={stat?.id}
          className="card-glass p-4 text-center"
          style={{ borderColor: `${stat?.accent}20` }}
        >
          <p className="text-3xl font-extrabold text-tabular mb-1" style={{ color: stat?.accent }}>
            {stat?.value}
          </p>
          <p className="text-xs font-semibold uppercase tracking-wide" style={{ color: 'var(--muted-foreground)', letterSpacing: '0.06em' }}>
            {stat?.label}
          </p>
        </div>
      ))}
    </div>
  );
}